module.exports = __webpack_public_path__ + "img/bus_0.91bbbe94.png";